
import { ChangeDetectionStrategy, Component, OnInit, SimpleChanges } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { SelectBoxComponent } from '@app/customizer/components/select-box/select-box';
import { ToggleComponent } from '@app/shared/components/toggle/toggle.component';
import { MiscModel } from '@models/misc-model';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantModel } from '@models/component-variant';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { ConfigurationModel } from '@models/configuration';
import { CustomizerMenuPartModel } from '@models/customizer-menu-part';
import { ModelGroupModel } from '@models/model-group';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ImageService } from '@services/image.service';
import { ComponentVariantFromApiModel } from '../../../../_models/api-models/component-variant-fromapi';
import { SorterService } from '../../../../_services/sorter.service';
import { AngleConstants } from '../../../../shared/angle-constants';
import { CustomizerStateConstants } from '../../../../shared/customizer-state-constants';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
	selector: 'clip-on-component',
	styleUrls: ['./clip-on.component.scss'],
	templateUrl: './clip-on.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [CustomizerComponentHeaderComponent, TranslatePipe, SelectBoxComponent, ToggleComponent]
})
export class ClipOnComponent extends BaseCustomizerComponent implements OnInit {

	public designs: Array<ComponentVariantFromApiModel> = [];
	public noDesign: boolean = false;
	public onlyClipOnChecked: boolean = false;
	public isEditOrder = CustomizerStateConstants.EDITORDER;


	public static override shouldBeVisible = (modelGroup: ModelGroupModel | undefined, menuComponents: CustomizerMenuPartModel, variants: Array<ComponentVariantModel> | undefined, configurations: Array<ConfigurationModel>, demo: boolean, chosenCase?: MiscModel | null): boolean => {
		return true;
	}

	constructor(
		public override events: EventsService,
		private imageService: ImageService,
		public apiService: DataApiService,
		public sorter: SorterService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		const x = await this.fetchData();

		if (!x) {
			this.noDesign = true;
		} else {
			this.designs = x;
		}

		this.onlyClipOnChecked = this.variants.length == 1 ? true : false;

		this.events.showLoader(false);
		this.setImageSliderByName(AngleConstants.Perspective);
	}

	onChanges(changes: SimpleChanges): void {
	}

	getImage = (variant: ComponentVariantFromApiModel) => this.imageService.GetVariantImage(variant.ToComponentVariantModel(""));

	// Safe getter for current variant color to prevent undefined access
	get currentVariantColor() {
		return this.getSelectedVariant?.VariantColor || null;
	}

	// Safe getter for determining if current variant is not selected
	get currentVariantNotSelected() {
		return this.getSelectedVariant?.NotSelected ?? false;
	}

	onSelected(selected: ComponentVariantFromApiModel) {
		const old = this.getSelectedVariant;

		const newVariant = selected != null
			? selected.ToComponentVariantModel(old ? old.Engraving : "", old ? old.OrderLineUuid : undefined, true)
			: undefined;

		if (newVariant) {
			newVariant.VariantSize = selected.VariantSizes[0];
			newVariant.VariantColor = selected.VariantSizes[0].VariantColors[0];
		}

		this.updateVariant(new ComponentVariantChangeModel(old, newVariant, null));
	}

	setClipOnOnly(clipOnOnly: boolean) {
		this.onlyClipOnChecked = clipOnOnly;
		this.updateClipOnOnly(clipOnOnly);
	}

	async fetchData() {
		const variant = this.getSelectedVariant;

		if (variant) {
			variant.VariantViewed = true;
		}

		const res = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, this.menu.menuComponents[0].ComponentUuids);

		await this.RunDisablingSystem(res);

		return res?.sort(this.sorter.sortBy(ComponentVariantFromApiModel));
	}

}
